import {getMomentTime} from "utils";

export function TrainingsGridData(note) {
    this.id = note.id;
    this.range = note.range;
    this.position = note.position + 1;
    this.maxRowWidth = note.biggestCliqueSize;
    this.startTime = this.range.length !== 0 ? this.range[0] : 0;
    this.endTime = note.endTime.format('HH:mm');
    this.height = (note.endTime - note.startTime) / 60000;
    this.offsetY = this.range.length !== 0 ? (note.startTime - getMomentTime(this.range[0])) / 60000 : 0;
    this.data = note.data;
    this.date = note.date;
}